import { IAppState } from '../../common/state';

export function getIsDealSaleBannerRotationEnabled(state: IAppState): boolean {
  return state.isDealSaleBannerRandomRotationEnabled;
}
